import { useMutation } from 'react-query';

import { type MutationFunction, useRequest } from '@frontend/api';

export type CalculateBomPricesRequestBody = {
  quoteItemId: number;
  componentIds?: number[];
};

export const useCalculateBomPrices: MutationFunction<
  null,
  CalculateBomPricesRequestBody
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(({ quoteItemId, componentIds }) => {
    return request(
      `/quotes/items/${quoteItemId}/bom_builder_calculate_prices/`,
      {
        query,
        init: {
          method: 'POST',
          body: componentIds !== undefined ? { componentIds } : {},
        },
      },
    );
  }, queryOptions);
};
